import {APP_GHA_BIDDING_API_ENDPOINT} from "../../../../../constants/api_urls";

export const apiUrlActiveMultipliers = {
    "GHA_META": {
        "device": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-device/`,
        "los": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-los/`,
        "check_in_day" : `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-check-in-day/`,
        "days_to_arrival": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-days-to-arrival/`,
        "date_type": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-date-type/`,
        "need_date": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/meta/active-multipliers-need-date/`,
    },
    "GHA_PPA": {
        "device": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-device/`,
        "los": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-los/`,
        "check_in_day" : `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-check-in-day/`,
        "days_to_arrival": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-days-to-arrival/`,
        "date_type": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-date-type/`,
        "need_date": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/ppa/active-multipliers-need-date/`,
    },
    "filters": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/active-bidding-filters/`,
    "platform": {
        "hotels": {
            "GHA_META": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/hotels/delete-bids/`,
            "GHA_PPA": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/hotels/delete-bids/`,
        },
        "groups": {
            "GHA_META": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/groups/delete-bids/`,
            "GHA_PPA": `${APP_GHA_BIDDING_API_ENDPOINT}/api/google-hotel-ads/groups/delete-bids/`,
        }
    }
};